export default __webpack_public_path__ + "static/media/arrow_rise.ea66de3d.svg";